/**
 * @generated SignedSource<<dc936b27e2ae453af7b3e5671c9ec2c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoreHomePageQuery$variables = Record<PropertyKey, never>;
export type StoreHomePageQuery$data = {
  readonly session: {
    readonly currentClientProfile: {
      readonly member: {
        readonly club: {
          readonly name: string;
          readonly " $fragmentSpreads": FragmentRefs<"FacilityLogoFragment_club">;
        };
      } | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"StoreHomeDesktop_session" | "useIsUserSignedIn_session">;
  } | null | undefined;
};
export type StoreHomePageQuery = {
  response: StoreHomePageQuery$data;
  variables: StoreHomePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v1/*: any*/),
  (v2/*: any*/)
],
v4 = {
  "kind": "Literal",
  "name": "status",
  "value": "ACTIVE"
},
v5 = {
  "kind": "Literal",
  "name": "type",
  "value": "MEMBERSHIP"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "kind": "Literal",
  "name": "status",
  "value": "UPCOMING"
},
v9 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MemberPackageEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MemberPackage",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "package",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v10 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v11 = {
  "kind": "Literal",
  "name": "assignable",
  "value": true
},
v12 = {
  "kind": "Literal",
  "name": "first",
  "value": 4
},
v13 = {
  "kind": "Literal",
  "name": "saleAvailability",
  "value": "PUBLIC"
},
v14 = [
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "PackageEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isPackage"
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DisplayInApp",
            "kind": "LinkedField",
            "name": "displayInApp",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingOption",
            "kind": "LinkedField",
            "name": "billingOptions",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingCharge",
                "kind": "LinkedField",
                "name": "billingCharges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "frequency",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SquareItemVariation",
                    "kind": "LinkedField",
                    "name": "squareVariation",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "amount",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minimumCommitmentMonths",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BenefitsSummaryLine",
            "kind": "LinkedField",
            "name": "benefitsSummary",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "billingType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activeUntilPeriod",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activeUntilPeriodUnit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activeUntilPeriodType",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "StoreHomePageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StoreHomeDesktop_session"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useIsUserSignedIn_session"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "FacilityLogoFragment_club"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "StoreHomePageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ],
                        "concreteType": "MemberPackageConnection",
                        "kind": "LinkedField",
                        "name": "memberPackages",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": "memberPackages(status:\"ACTIVE\",type:\"MEMBERSHIP\")"
                      },
                      {
                        "alias": "upcomingMemberPackages",
                        "args": [
                          (v8/*: any*/),
                          (v5/*: any*/)
                        ],
                        "concreteType": "MemberPackageConnection",
                        "kind": "LinkedField",
                        "name": "memberPackages",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": "memberPackages(status:\"UPCOMING\",type:\"MEMBERSHIP\")"
                      },
                      {
                        "alias": "activePackages",
                        "args": [
                          (v4/*: any*/)
                        ],
                        "concreteType": "MemberPackageConnection",
                        "kind": "LinkedField",
                        "name": "memberPackages",
                        "plural": false,
                        "selections": (v9/*: any*/),
                        "storageKey": "memberPackages(status:\"ACTIVE\")"
                      },
                      {
                        "alias": "upcomingPackages",
                        "args": [
                          (v8/*: any*/)
                        ],
                        "concreteType": "MemberPackageConnection",
                        "kind": "LinkedField",
                        "name": "memberPackages",
                        "plural": false,
                        "selections": (v9/*: any*/),
                        "storageKey": "memberPackages(status:\"UPCOMING\")"
                      }
                    ],
                    "type": "Customer",
                    "abstractKey": null
                  },
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "slug",
                        "storageKey": null
                      },
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "supportsPublic",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "logoImage",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "publicId",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "renderingKey",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          (v11/*: any*/),
                          (v12/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "packageType",
                            "value": "STANDARD"
                          },
                          (v13/*: any*/)
                        ],
                        "concreteType": "PackageConnection",
                        "kind": "LinkedField",
                        "name": "packages",
                        "plural": false,
                        "selections": (v14/*: any*/),
                        "storageKey": "packages(assignable:true,first:4,packageType:\"STANDARD\",saleAvailability:\"PUBLIC\")"
                      },
                      {
                        "alias": "memberships",
                        "args": [
                          (v11/*: any*/),
                          (v12/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "packageType",
                            "value": "MEMBERSHIP"
                          },
                          (v13/*: any*/)
                        ],
                        "concreteType": "PackageConnection",
                        "kind": "LinkedField",
                        "name": "packages",
                        "plural": false,
                        "selections": (v14/*: any*/),
                        "storageKey": "packages(assignable:true,first:4,packageType:\"MEMBERSHIP\",saleAvailability:\"PUBLIC\")"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e08da4fe1aea27d7b9c73cf391a92ba7",
    "id": null,
    "metadata": {},
    "name": "StoreHomePageQuery",
    "operationKind": "query",
    "text": "query StoreHomePageQuery {\n  session {\n    ...StoreHomeDesktop_session\n    ...useIsUserSignedIn_session\n    currentClientProfile {\n      __typename\n      member {\n        __typename\n        club {\n          name\n          ...FacilityLogoFragment_club\n          id\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment FacilityLogoFragment_club on Club {\n  logoImage {\n    publicId: renderingKey\n  }\n}\n\nfragment PackageBenefitsSummary_package on Package {\n  __isPackage: __typename\n  benefitsSummary {\n    description\n  }\n}\n\nfragment PackageItemActions_package on Package {\n  __isPackage: __typename\n  id\n  __typename\n  ...StorePackageModal_package\n}\n\nfragment PackageItemActions_session on Session {\n  ...StorePackageModal_session\n}\n\nfragment PackagePriceDisplay_package on Package {\n  __isPackage: __typename\n  ...useGetPackagePriceMap_package\n}\n\nfragment StoreHomeDesktop_session on Session {\n  ...StoreProductList_session\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        packages(packageType: STANDARD, first: 4, assignable: true, saleAvailability: PUBLIC) {\n          count\n          ...StoreProductList_packageConnection\n        }\n        memberships: packages(packageType: MEMBERSHIP, first: 4, assignable: true, saleAvailability: PUBLIC) {\n          count\n          ...StoreProductList_packageConnection\n        }\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment StorePackageAuth_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        id\n        slug\n        name\n        supportsPublic\n        logoImage {\n          publicId: renderingKey\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment StorePackageDetailFooter_package on Package {\n  __isPackage: __typename\n  id\n  __typename\n  ...usePackageDisplayName_package\n}\n\nfragment StorePackageDetailFooter_session on Session {\n  ...useIsUserSignedIn_session\n  ...useCustomerHasActiveOrUpcomingMembership_session\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Customer {\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment StorePackageDetail_package on Package {\n  __isPackage: __typename\n  ...PackageBenefitsSummary_package\n  ...StorePackageSummary_package\n  id\n}\n\nfragment StorePackageModal_package on Package {\n  __isPackage: __typename\n  ...StorePackageDetail_package\n  ...usePackageDisplayName_package\n  ...StorePackageDetailFooter_package\n  ...StorePackageSuccess_package\n}\n\nfragment StorePackageModal_session on Session {\n  ...StorePackageDetailFooter_session\n  ...StorePackageAuth_session\n}\n\nfragment StorePackageSuccess_package on Package {\n  __isPackage: __typename\n  __typename\n}\n\nfragment StorePackageSummary_package on Package {\n  __isPackage: __typename\n  id\n  __typename\n  billingType\n  startOn\n  endOn\n  activeUntilPeriod\n  activeUntilPeriodUnit\n  activeUntilPeriodType\n  ...useGetPackagePriceMap_package\n  ...useGetMinimumCommitment_package\n}\n\nfragment StoreProductList_packageConnection on PackageConnection {\n  edges {\n    node {\n      __typename\n      id\n      ...StoreProductPackageItem_package\n    }\n  }\n}\n\nfragment StoreProductList_session on Session {\n  ...StoreProductPackageItem_session\n}\n\nfragment StoreProductPackageItem_package on Package {\n  __isPackage: __typename\n  id\n  __typename\n  name\n  displayInApp {\n    displayName\n  }\n  ...PackagePriceDisplay_package\n  ...PackageBenefitsSummary_package\n  ...PackageItemActions_package\n}\n\nfragment StoreProductPackageItem_session on Session {\n  ...PackageItemActions_session\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Customer {\n        activePackages: memberPackages(status: ACTIVE) {\n          edges {\n            node {\n              id\n              package {\n                __typename\n                id\n              }\n            }\n          }\n        }\n        upcomingPackages: memberPackages(status: UPCOMING) {\n          edges {\n            node {\n              id\n              package {\n                __typename\n                id\n              }\n            }\n          }\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useCustomerHasActiveOrUpcomingMembership_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Customer {\n        id\n        memberPackages(status: ACTIVE, type: MEMBERSHIP) {\n          count\n        }\n        upcomingMemberPackages: memberPackages(status: UPCOMING, type: MEMBERSHIP) {\n          count\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useGetMinimumCommitment_package on Package {\n  __isPackage: __typename\n  id\n  billingOptions {\n    minimumCommitmentMonths\n  }\n}\n\nfragment useGetPackagePriceMap_package on Package {\n  __isPackage: __typename\n  billingOptions {\n    billingCharges {\n      frequency\n      squareVariation {\n        amount\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment useIsUserSignedIn_session on Session {\n  user {\n    __typename\n    id\n  }\n}\n\nfragment usePackageDisplayName_package on Package {\n  __isPackage: __typename\n  displayInApp {\n    displayName\n  }\n  name\n}\n"
  }
};
})();

(node as any).hash = "c7ab22b32fafabd7ed973b21444d5d15";

export default node;
